import { renderIcon } from "@/utils"
import { h } from "vue"
import { RouterLink } from "vue-router"
import type { MenuMixedOption } from "naive-ui/es/menu/src/interface"

const CardsIcon = "fluent:people-community-24-regular"
const EmailIcon = "carbon:email"
const AcademyIcon = "carbon:education"
const ChatIcon = "carbon:chat"
const NotesIcon = "fluent:news-24-regular"
const CalendarIcon = "carbon:calendar"

export default function getItems(mode: "vertical" | "horizontal", collapsed: boolean): MenuMixedOption[] {
	return [
        {
            label: () =>
                h(
                    RouterLink,
                    {
                        to: {
                            name: "Dashboard"
                        }
                    },
                    { default: () => "Dashboard" }
                ),
            key: "Dashboard",
            icon: renderIcon(NotesIcon)
        },
        {
            key: "Community",
            label: "Connections",
            icon: renderIcon(CardsIcon),
            children: [
                {
                    label: () =>
                        h(
                            RouterLink,
                            {
                                to: {
                                    name: "Community-Players"
                                }
                            },
                            { default: () => "Players" }
                        ),
                    key: "Community-Players"
                },
                {
                    label: () =>
                        h(
                            RouterLink,
                            {
                                to: {
                                    name: "Community-Trainers"
                                }
                            },
                            { default: () => "Trainers" }
                        ),
                    key: "Community-Trainers"
                },
                {
                    label: () =>
                        h(
                            RouterLink,
                            {
                                to: {
                                    name: "Community-Managers"
                                }
                            },
                            { default: () => "Managers" }
                        ),
                    key: "Community-Managers"
                },
                {
                    label: () =>
                        h(
                            RouterLink,
                            {
                                to: {
                                    name: "Community-Clubs"
                                }
                            },
                            { default: () => "Clubs" }
                        ),
                    key: "Community-Clubs"
                }
            ]
        },
        {
            label: () =>
                h(
                    RouterLink,
                    {
                        to: {
                            name: "Apps-Academy"
                        }
                    },
                    { default: () => "Academy" }
                ),
            key: "Apps-Academy",
            icon: renderIcon(AcademyIcon)
        },
        {
            label: () =>
                h(
                    RouterLink,
                    {
                        to: {
                            name: "Apps-Forum"
                        }
                    },
                    { default: () => "Forum" }
                ),
            key: "Apps-Forum",
            icon: renderIcon(EmailIcon)
        },
        {
            label: () =>
                h(
                    RouterLink,
                    {
                        to: {
                            name: "Apps-Chat"
                        }
                    },
                    { default: () => "Chat" }
                ),
            key: "Apps-Chat",
            icon: renderIcon(ChatIcon)
        }

	]
}
